import { render, staticRenderFns } from "./LibraryElementScaleConfigTableColumn.vue?vue&type=template&id=c8b60838"
import script from "./LibraryElementScaleConfigTableColumn.vue?vue&type=script&lang=js"
export * from "./LibraryElementScaleConfigTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports